import { PermissionKey } from '@/lib/utils/permissions';

export const routePermissions: Record<string, PermissionKey | PermissionKey[]> = {
  // Warranty System
  '/warranty': 'warranty',
  '/warranty/*': 'warranty',
  
  // Contact Center (unified permission key)
  '/contact-center/agent-console': 'contact_center',
  '/contact-center/queue-management': 'contact_center',
  '/contact-center/call-history': 'contact_center',
  '/contact-center/*': 'contact_center',
  '/call-center/*': 'contact_center',
  
  // System Monitoring
  '/system-overview': 'monitoring',
  '/monitoring': 'monitoring',
  '/monitoring/*': 'monitoring',
  
  // Error Tracking
  '/errors': 'errors',
  '/error-logs': 'errors',
  
  // Analytics
  '/analytics': 'analytics',
  '/analytics/*': 'analytics',
  
  // Performance
  '/performance': 'performance',
  '/performance/*': 'performance',
  
  // Plans Manager
  '/plans': 'plans',
  '/plans/*': 'plans',
  
  // Customers
  '/customers': 'customers',
  '/customers/*': 'customers',
  
  // Reviews
  '/reviews': 'reviews',
  '/reviews/*': 'reviews',
  
  // Data Import
  '/data-import': 'imports',
  '/imports': 'imports',
  '/integrations/import-management': 'imports',
  '/integrations/customer-import-trigger': 'imports',
  '/integrations/incremental-true-up': 'imports',
  '/integrations/successware-full-import': 'imports',
  '/integrations/successware-incremental-import': 'imports',
  '/integrations/successware-true-up': 'imports',
  '/integrations/data-ingestion-visualization': 'imports',
  '/customers/full-historical-import': 'imports',
  
  // Integrations
  '/integrations': 'integrations',
  '/integrations/*': 'integrations',
  
  // Sales & Revenue
  '/sales': 'sales',
  '/revenue': 'sales',
  '/sales/*': 'sales',
  
  // Memberships
  '/memberships': 'memberships',
  '/memberships/*': 'memberships',
  
  // Traffic & Funnels
  '/traffic': 'traffic',
  '/funnels': 'traffic',
  
  // Conversions
  '/conversions': 'conversions',
  '/conversions/*': 'conversions',
  
  // API Diagnostics
  '/api-diagnostics': 'api',
  '/api': 'api',
  
  // Renewals
  '/renewals': 'renewals',
  '/renewals/*': 'renewals',
  
  // Audit Log
  '/audit': 'audit',
  '/audit-log': 'audit',
  
  // Users & Roles
  '/users': 'users',
  '/users/*': 'users',
  '/roles': 'users',
  
  // Exports
  '/exports': 'exports',
  '/exports/*': 'exports',
  
  // Settings
  '/settings': 'settings',
  '/settings/*': 'settings',
  
  // AI Voice Agents - requires either contact_center OR integrations permission
  '/ai-voice-agents': ['contact_center', 'integrations'],
  '/ai-voice-agents/*': ['contact_center', 'integrations'],
};

/**
 * Get required permission(s) for a route
 * @param path - The route path to check
 * @returns The required permission key(s), or null if no permission required
 */
export function getRoutePermissions(path: string): PermissionKey | PermissionKey[] | null {
  // Exact match first
  if (routePermissions[path]) {
    return routePermissions[path];
  }
  
  // Wildcard match - check if path starts with any pattern base
  for (const [pattern, permission] of Object.entries(routePermissions)) {
    if (pattern.endsWith('/*')) {
      const base = pattern.slice(0, -2);
      if (path.startsWith(base)) {
        return permission;
      }
    }
  }
  
  // No permission required for this route
  return null;
}
